import { render } from "./result.vue?vue&type=template&id=6fd84402&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=6fd84402&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd84402"]])

export default __exports__